import React from 'react'
import { Switch } from 'antd'
import { BulbFilled } from '@ant-design/icons'

import { useDispatch, useSelector } from 'react-redux'
import { toogle_setting } from '../../../../redux/slice/settings'

const Theme = () => {
  const dispatch = useDispatch()
  const isDarkAlgoritm = useSelector(s => s._settings.antd_darkAlgorithm)

  const onClick = () => {
    dispatch(toogle_setting('antd_darkAlgorithm'))
  }

  return (
    <div style={{ marginRight: '0.5rem' }}>
      <Switch
        checked={!isDarkAlgoritm}
        checkedChildren={<BulbFilled style={{ color: 'yellow' }} />}
        unCheckedChildren={<BulbFilled style={{ color: 'black' }} />}
        onClick={onClick}
        style={{ backgroundColor: isDarkAlgoritm && 'rgba(0, 0, 0, 0.25)' }}
      />
    </div>
  )
}

export default Theme
